import {
  API_ERROR,
  SR_RFQ_LIST,
  SR_RFQ_LIST_SUCCESS,
  SR_Q_VENDORS_LIST,
  SR_Q_VENDORS_LIST_SUCCESS,
  INPUT_SR_CHANGEVALUE,
  RFQ_NO_SELECT_SR_CHANGEVALUE,
  SELECT_SR_CHANGEVALUE,
  SR_RFQ_ROW_DATA,
  SR_RFQ_ROW_DATA_SUCCESS,
  SR_QSR_ITEM_REMOVE,
  SR_ITEM_QTY_SR_CHANGEVALUE,
  SR_ITEM_UNIT_SR_CHANGEVALUE,
  SR_ITEM_PRICE_SR_CHANGEVALUE,
  SR_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
  SR_ITEM_BASEPRICE_SR_CHANGEVALUE,
  SR_ITEM_TAXTYPE_SR_CHANGEVALUE,
  SR_ITEM_TAX_SR_CHANGEVALUE,
  SR_ITEM_GROSS_VAL_SR_CHANGEVALUE,
  SR_QUOTATION_ADD,
  SR_QUOTATION_LIST,
  SR_QUOTATION_LIST_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_SR_CHANGEVALUE,
  FILTER_SELECT_SR_CHANGEVALUE,
  TOGGLE_SR_ITEM_MENU,
  Q_SR_MODEL_LIST_OPEN,
  Q_SR_MODEL_LIST_CLOSE,
  SR_QOUTATION_DATA,
  SR_QOUTATION_DATA_SUCCESS,
  SR_LIST_LAYOUT,
  SRQ_FILTERS_SHOW_RIGHT_SIDEBAR,
  SR_FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  RFQ_SR_FILTERS_LIST,
  RFQ_SR_FILTERS_LIST_SUCCESS,
  SR_MR_CODE_DETAILS,
  SR_MR_CODE_DETAILS_SUCCESS,
  SR_PI_CODE_DETAILS,
  SR_PI_CODE_DETAILS_SUCCESS,
  MR_SR_ITEM_IMAGES,
  MR_SR_ITEM_IMAGES_SUCCESS,
  RFQ_MR_SR_ITEM_IMAGES_SR_MODEL_CLOSE,
} from "./actionTypes";

export const getRFQList = (data) => {
  return {
    type: SR_RFQ_LIST,
    payload: { data },
  };
};
export const getRFQListSuccessful = (response) => {
  return {
    type: SR_RFQ_LIST_SUCCESS,
    payload: response,
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_SR_CHANGEVALUE,
    payload: { key, value },
  };
};
export const rfqNoSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: RFQ_NO_SELECT_SR_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_SR_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId, byVendor) => {
  return {
    type: SR_RFQ_ROW_DATA,
    payload: { rfqId, byVendor },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: SR_RFQ_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const QItemRemove = (data) => {
  return {
    type: SR_QSR_ITEM_REMOVE,
    payload: data,
  };
};
export const getQuotationtVendorsList = (rfqId) => {
  return {
    type: SR_Q_VENDORS_LIST,
    payload: { rfqId },
  };
};
export const QuotationtVendorsListSuccessful = (response) => {
  return {
    type: SR_Q_VENDORS_LIST_SUCCESS,
    payload: response,
  };
};

export const itemQtyChangeValue = ({ key, value, item }) => {
  return {
    type: SR_ITEM_QTY_SR_CHANGEVALUE,
    payload: { key, value, item },
  };
};
export const itemUnitSelecteChangeValue = ({
  key,
  label,
  key2,
  value,
  item,
}) => {
  return {
    type: SR_ITEM_UNIT_SR_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};
export const itemPriceChangeValue = ({
  key,
  value,
  discount,
  discountpercent,
  item,
}) => {
  return {
    type: SR_ITEM_PRICE_SR_CHANGEVALUE,
    payload: { key, value, discount, discountpercent, item },
  };
};
export const itemDiscountPercentChangeValue = ({
  key,
  value,
  price,
  discount,
  item,
}) => {
  return {
    type: SR_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
    payload: { key, value, price, discount, item },
  };
};
export const itemBasePriceChangeValue = ({
  key,
  value,
  price,
  discount,
  item,
}) => {
  return {
    type: SR_ITEM_BASEPRICE_SR_CHANGEVALUE,
    payload: { key, value, price, discount, item },
  };
};

export const itemTaxTypeSelecteChangeValue = ({
  key,
  label,
  key2,
  value,
  item,
}) => {
  return {
    type: SR_ITEM_TAXTYPE_SR_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};
export const itemTaxSelecteChangeValue = ({ id, name, tax, item }) => {
  return {
    type: SR_ITEM_TAX_SR_CHANGEVALUE,
    payload: { id, name, tax, item },
  };
};
export const itemGrossValChangeValue = (taxamt, net, item) => {
  return {
    type: SR_ITEM_GROSS_VAL_SR_CHANGEVALUE,
    payload: { taxamt, net, item },
  };
};
export const quotationAdd = (data, qoutId, history) => {
  return {
    type: SR_QUOTATION_ADD,
    payload: { data, qoutId, history },
  };
};
export const getSRQuotationtList = (data) => {
  return {
    type: SR_QUOTATION_LIST,
    payload: { data },
  };
};
export const QuotationtListSuccessful = (response) => {
  return {
    type: SR_QUOTATION_LIST_SUCCESS,
    payload: response,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_SR_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_SR_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_SR_ITEM_MENU,
    payload: id,
  };
};
export const Q_model_list_open = (qId) => {
  return {
    type: Q_SR_MODEL_LIST_OPEN,
    payload: { qId },
  };
};
export const Q_model_list_close = () => {
  return {
    type: Q_SR_MODEL_LIST_CLOSE,
  };
};
export const getQuotationData = (qId) => {
  return {
    type: SR_QOUTATION_DATA,
    payload: { qId },
  };
};
export const QuotationDatasuccessfull = (quotation) => {
  return {
    type: SR_QOUTATION_DATA_SUCCESS,
    payload: quotation,
  };
};
export const listlayout = (layout) => {
  return {
    type: SR_LIST_LAYOUT,
    payload: layout,
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: SRQ_FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: SR_FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const getRFQFilterList = (data) => {
  return {
    type: RFQ_SR_FILTERS_LIST,
    payload: { data },
  };
};
export const getRFQFilterListSuccessful = (response) => {
  return {
    type: RFQ_SR_FILTERS_LIST_SUCCESS,
    payload: response,
  };
};
export const getMRCodeDetails = (ItemId) => {
  return {
    type: SR_MR_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getMRCodeDetailsSuccessful = (response) => {
  return {
    type: SR_MR_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getPICodeDetails = (ItemId) => {
  return {
    type: SR_PI_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getPICodeDetailsSuccessful = (response) => {
  return {
    type: SR_PI_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getMRItemImges = (rfqItemId) => {
  return {
    type: MR_SR_ITEM_IMAGES,
    payload: { rfqItemId },
  };
};
export const getMRItemImgesSuccessful = (response) => {
  return {
    type: MR_SR_ITEM_IMAGES_SUCCESS,
    payload: response,
  };
};
export const RFQMRItemImagesModel_close = () => {
  return {
    type: RFQ_MR_SR_ITEM_IMAGES_SR_MODEL_CLOSE,
    payload: null,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
